import { buildSavedViewFiltersJson, parseSavedViewFilters } from '../../shared/saved-views/saved-view-filters';

/** Multi-select filter shape of the module overview, serialized into `SavedView.filtersJson` (NEX-788). */
export interface ModuleSavedViewFilters {
  query: string | null;
  status: string[];
  author: string[];
}

const EMPTY_MODULE_SAVED_VIEW_FILTERS: ModuleSavedViewFilters = {
  query: null,
  status: [],
  author: [],
};

export function parseModuleSavedViewFilters(filtersJson: string | null): ModuleSavedViewFilters {
  return parseSavedViewFilters(filtersJson, EMPTY_MODULE_SAVED_VIEW_FILTERS);
}

export function buildModuleSavedViewFiltersJson(filters: ModuleSavedViewFilters): string {
  return buildSavedViewFiltersJson(filters);
}
